/*
SaiKrishna 10/06/2022  2698403495 Removed unnecessary console.log statements
*/
import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpPaginationGet, httpPostCore} from '../../util/Rest';
import {DEBTOR, DOCUMENT, LOOKUP} from '../../constants/MicroServiceConstants';
import {DOC_TYPE} from '../../constants/Lookup';
import {deleteWorkQueueByAccountNumber} from './WorkQueue';

const initialData = {
  documentManagementData: [],
  viewDocumentManagementData: [],
  dropDownData: {},
  subType: [],
  documentManagementStatus: null,
  scanStatus: null,
  documentStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  fileAvailable: false,
};

const slice = createSlice({
  name: 'documentManagement',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    getDocumentManagementData: (state, action) => {
      state.documentManagementData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchSubType: (state, action) => {
      state.subType = action.payload.response;
      state.isLoading = false;
      state.errorMsg = null;
    },
    viewDocumentManagementData: (state, action) => {
      state.fileAvailable = action?.payload?.document ? true : false;
      state.viewDocumentManagementData = action.payload.document;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postDocumentManagementData: (state, action) => {
      state.documentManagementStatus = action.payload.status;
      state.documentManagementData = action.payload.resultObjects;
      state.isLoading = false;
      state.errorMsg = null;
      // state.successMsg = action.payload.message;
    },
    scanDocumentManagementData: (state, action) => {
      state.scanStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = action.payload.status != 200 ? action.payload.message : null;
      state.successMsg = action.payload.status == 200 ? action.payload.message : null;
    },
    deleteDocumentManagementData: (state, action) => {
      state.documentStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = action?.payload?.error ? action.payload.error : null;
      state.successMsg = action.payload.response;
    },
    putDocumentManagementData: (state, action) => {
      state.documentManagementStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = action.payload.status != 200 ? action.payload.message : null;
      state.successMsg = action.payload.status == 200 ? action.payload.message : null;
    },
    resetDocumentManagementStatus: (state) => {
      state.documentManagementStatus = null;
      state.scanStatus = null;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetViewDocument: (state) => {
      state.viewDocumentManagementData = [];
      state.isLoading = false;
      state.successMsg = null;
      state.errorMsg = null;
      state.fileAvailable = false;
    },
    resetDeleteDocument: (state) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.isLoading = false;
    },
    resetEditDocument: (state) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : null;
      state.isLoading = false;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  postDocumentManagementData,
  fetchDropDownData,
  resetDocumentManagementStatus,
  resetViewDocument,
  resetDeleteDocument,
  resetEditDocument,
  putDocumentManagementData,
  scanDocumentManagementData,
  deleteDocumentManagementData,
  viewDocumentManagementData,
  fetchStart,
  fetchSubType,
  resetMsg,
  fetchError,
} = slice.actions;

export const postDocumentManagement = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${DEBTOR}/search/attachmentinfo`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postDocumentManagementData(data.response));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const viewDocumentPost = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPostCore(`docs/signer/cdn`, details)
      .then((response) => {
        if (response && response.status && response.status === 200) {
          dispatch(viewDocumentManagementData(response.data));
        } else {
          dispatch(fetchError(response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const scanDocumentManagement = (details, accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${DOCUMENT}/save/scandetials`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(scanDocumentManagementData(data));
          dispatch(deleteWorkQueueByAccountNumber({accountNumber, isDirty: true}));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const putDocumentManagement = (details, {accountNumber, isDirty}) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${DEBTOR}/edit/attachmentinfo`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(putDocumentManagementData(data.response));
          dispatch(deleteWorkQueueByAccountNumber({accountNumber, isDirty}));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const deleteDocument = (accountDocumentId, accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPaginationGet(`${DEBTOR}/delete/document/${accountDocumentId}`)
      .then((data) => {
        if (data.response && data.status === 200) {
          dispatch(deleteDocumentManagementData(data));
          dispatch(deleteWorkQueueByAccountNumber({ accountNumber, isDirty: true }));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const ViewDocument = (docKey) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${DOCUMENT}/generateUrl`, {dockey: docKey})
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(viewDocumentManagementData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const resetDocumentManagement = () => {
  return (dispatch) => {
    dispatch(resetDocumentManagementStatus());
  };
};

export const resetViewDocumentManagement = () => {
  return (dispatch) => {
    dispatch(resetViewDocument());
  };
};

export const resetDeleteDocumentManagement = () => {
  return (dispatch) => {
    dispatch(resetDeleteDocument());
  };
};

export const resetEditDocumentManagement = () => {
  return (dispatch) => {
    dispatch(resetEditDocument());
  };
};

export const resetToast = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};

export const fetchDocumentManagement = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [DOC_TYPE],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const docSubType = (valueCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${LOOKUP}/find/childvalue`, valueCode)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchSubType(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
